import { Boolean, Number, Record, Static, String, Array } from 'runtypes'

export const CanUseErecipeShipment = Record({
    isErecipeInput: Boolean
})

export const CanUseErecipe = Record({
    pickup: CanUseErecipeShipment,
    delivery: CanUseErecipeShipment
})

export const PrescriptionGood = Record({
    goodsID: Number,
    kTRUCode: String,
    goodsUnitCount: Number,
    prescriptionPart: Number,
    validationStatus: Number,
    validationMessage: String
})

export const GuidsConvert = Record({
    sourceGuid: String,
    targetGuid: String
})

export const Prescription = Record({
    isCommercial: Boolean,
    prescriptionGuid: String,
    unitsCount: Number,
    maxPartsSum: Number
    // goods: Array(PrescriptionGood)
})
export const PrescriptionFull = Record({
    allPrescriptions: Array(Prescription),
    newPrescriptions: Array(Prescription)
})
export type IPrescription = Static<typeof Prescription>
export type ICanUseErecipe = Static<typeof CanUseErecipe>
export type IGuidsConvert = Static<typeof GuidsConvert>
export type IPrescriptionFull = Static<typeof PrescriptionFull>
